<template>
  <div>
    <formio :src="demoformio"></formio>
    <router-link class="btn btn-primary" :to="{ name: 'allSubmissions' }">Todos mis submissions</router-link>
  </div>
</template>

<script>
import { FORMIO_ENDPOINT } from "@/api/formioApi";
import { mapActions } from "vuex";
import { Form } from "vue-formio";
import { Formio } from "formiojs";

export default {
  components: {
    formio: Form
  },
  computed: {
    demoformio() {
      return `${FORMIO_ENDPOINT}/demo/submission/${this.$route.params.id}`;
    }
  }
};
</script>